
import { Component, Prop, Vue } from 'vue-property-decorator';
import { paymentRecordTableColumns } from '@/helpers/project/PaymentRecordHelper';
import { getTableLocale } from '@/helpers/LocaleHelper';
import { Button, ConfigProvider, Popconfirm, Table } from 'ant-design-vue';
import Project from '@/models/Project';

@Component({
    name: 'PaymentRecordsTableNew',
    components: {
        ConfigProvider,
        Button,
        Popconfirm,
        Table,
    },
})
export default class PaymentRecordsTableNew extends Vue {
    @Prop({ required: true }) private project!: Project;
    @Prop({ required: true }) private selectedPayment!: string;

    private get paymentRecordsTableData() {
        if (this.project == null || this.project.paymentRecords == null) {
            return [];
        }

        return this.project.paymentRecords.map((paymentRecord) => {
            return {
                id: paymentRecord.id,
                amount: paymentRecord.amount,
                currency: paymentRecord?.currency?.name,
                paymentDate: new Date(paymentRecord.paymentDate).getTime(),
                percentage: paymentRecord.percentagePaid,
                offerNumber: paymentRecord?.offer?.id,
                sent: paymentRecord.toBeSent,
            };
        });
    }

    private get columns() {
        return paymentRecordTableColumns();
    }

    private get locale() {
        return getTableLocale();
    }

    private onSelectChange(rowId: string | Event) {
        // Emit event with current selection state
        this.$emit('selection-change', rowId);
    }
}
